import { Component, OnInit, Input } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';

@Component({
  selector: 'app-invalid-email',
  templateUrl: './invalid-email.component.html',
  styleUrls: ['./invalid-email.component.scss'],
})
export class InvalidEmailComponent implements OnInit {

  @Input() invalidEmail: string;

  constructor(private modalCtrl: ModalController, private navCtrl: NavController) { }

  ngOnInit() {}

  get bodyText(): BodyText[] {
    return [{
      text: `${this.invalidEmail} `,
      class: 'bold'
    }, {
      text: 'is not a valid email address. Please contact support to update your email address.'
    }];
  }

  async onDismiss() {
    await this.navCtrl.navigateForward(AppRoutingUtil.APPLICATION_HOME);
    await this.modalCtrl.dismiss();
  }

  async contactSupport() {
    let encodedEmail = encodeURIComponent(this.invalidEmail);
    window.open('mailto:support@bluecrewjobs.com?subject=Change%20email%20address%20for%20user:%20' + encodedEmail,'_system');
    await this.onDismiss();
  }

}

interface BodyText {
  text: string;
  class?: string;
};
